
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"17","viewBox":"0 0 13 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 6.99994C0 13.6409 6.09035 16.8974 6.09035 16.8974C6.3487 17.0342 6.6513 17.0342 6.90961 16.8974C6.90961 16.8974 13 13.641 13 6.99994C13 5.14404 12.3175 3.36389 11.0939 2.04995C9.88023 0.737815 8.22271 0 6.5 0C4.77732 0 3.11981 0.737815 1.90605 2.04995C0.682446 3.36389 0 5.14408 0 6.99994ZM1.85718 6.99994C1.85718 5.6747 2.34411 4.40339 3.21824 3.46542C3.21908 3.46435 3.22007 3.46345 3.22091 3.46254C4.08706 2.52565 5.27045 1.99998 6.5 1.99998C7.72959 1.99998 8.91294 2.52561 9.77909 3.46254C9.77992 3.46345 9.78092 3.46435 9.78176 3.46542C10.6559 4.40339 11.1429 5.67474 11.1429 6.99994C11.1429 11.5041 7.70334 14.0916 6.5 14.8589C5.2967 14.0916 1.85718 11.5041 1.85718 6.99994ZM6.5 8.49993C7.52143 8.49993 8.35718 7.60494 8.35718 6.49991C8.35718 5.39596 7.52143 4.50006 6.5 4.50006C5.47856 4.50006 4.64282 5.39596 4.64282 6.49991C4.64282 7.60489 5.4786 8.49993 6.5 8.49993Z","fill":"black"}})])
          )
        }
      }
    